import { takeEvery, call } from 'redux-saga/effects';

import { ACTIVE_VENUE_CHANGED } from 'features/App/App.saga';
import { makePath } from 'helpers/link-generation';

export function* handleActiveVenueChange(client, action) {
  const { venueId } = action;
  yield call(client.navigate, makePath.skuPayoutReports(venueId));
}

export function* watchActions(dependencies) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, dependencies);
}
